import { Collapse } from 'bootstrap';

// Handles accordion scrolling behavior
function scrollToAccordion(target: HTMLElement, collapseClass: string): void {
  const targetCollapse = target.querySelector(`.${collapseClass}`) as HTMLElement;

  if (targetCollapse) {
    const panel = Collapse.getOrCreateInstance(targetCollapse, { toggle: false });
    if (targetCollapse.classList.contains('show')) {
      // Scroll immediately if already open
      target.scrollIntoView({ block: 'start', behavior: 'smooth' });
    } else {
      // Wait for panel to expand fully, then scroll
      panel.show();
      targetCollapse.addEventListener('shown.bs.collapse', () => {
        target.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }, { once: true });
    }
  }
}

// Gets the target element from the hash value
function getTargetFromHash(hash: string): HTMLElement {
  return hash && hash.length > 1 ? document.querySelector(`[data-wf-anchor="${hash.substring(1)}"]`) as HTMLElement : null;
}

// Allows areas to be navigated to from URL hash
function handleAnchorTarget(target:HTMLElement): void {
  if (target) {
    let type = target.getAttribute('data-wf-anchor-type');
    switch (type) {
      case 'accordion': {
        scrollToAccordion(target, 'accordion-collapse');
        break;
      }
      case 'tab': {
        // Check if .nav-tabs is hidden (mobile view)
        const navTabs = target.closest('.nav-tabs') as HTMLElement;
        //const isHidden = window.getComputedStyle(navTabs).display === 'none';
        if (navTabs && !navTabs.offsetParent) {
          // Treat as accordion in mobile view
          target = document.querySelector(`[data-wf-anchor="accordion-${target.getAttribute('data-wf-anchor')}"]`) as HTMLElement;
          scrollToAccordion(target, 'accordion-tabs-collapse');
        } else {
          // Regular tab scrolling behavior
          target.click();
          navTabs.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
        break;
      }
      default: {
        console.log("Attribute 'data-wf-anchor-type' or it's value is undefined or wasn't matched.");
        break;
      }
    }
  }
}

// Run on page load
document.addEventListener('DOMContentLoaded', () => {
  handleAnchorTarget(getTargetFromHash(window.location.hash));
});

// Run when anchor link is clicked
document.addEventListener('click', (event) => {
  const anchor = event.target as HTMLAnchorElement;
  if (anchor) {
    var target = getTargetFromHash(anchor.hash)
    if (target) {
      event.preventDefault();
      handleAnchorTarget(target);
    }
  }
});

// Run when hash changes
window.addEventListener('hashchange', () => {
  handleAnchorTarget(getTargetFromHash(window.location.hash));
});
